import React, { useMemo, useState } from 'react';
import './BoardWrite.scss';

const PRODUCT_LIST = [
  '화지양면',
  '핫멜트양면',
  'PET90 양면',
  '크라프트양면',
  '인쇄양면 테이프',
  '마스킹테이프',
  '라인 테이프',
  /* '기능성 산업 테이프', */
  'EVA폼 테이프',
  'PE폼 테이프',
];

const BoardWrite = ({ type, onCancel, onSubmit }) => {
  const isQuote = type === 'quote';

  const [form, setForm] = useState({
    use_purpose: '',
    products: [],
    company_name: '',
    author_name: '',
    author_phone: '',
    author_email: '',
    address: '',
    quantity: '',
    password: '',
    is_private: true, // 무조건 비밀글로 처리
  });

  const pageTitle = useMemo(() => (isQuote ? '견적 요청' : '샘플 요청'), [isQuote]);
  const pageDesc = useMemo(
    () =>
      isQuote
        ? '수량과 제품군을 선택해 맞춤 견적을 문의하세요.'
        : '테스트가 필요한 제품을 선택하고 샘플 신청을 진행하세요.',
    [isQuote]
  );

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleToggleProduct = (product) => {
    setForm((prev) => {
      if (isQuote) {
        const exists = prev.products.includes(product);
        return {
          ...prev,
          products: exists ? prev.products.filter((item) => item !== product) : [...prev.products, product],
        };
      }
      return {
        ...prev,
        products: prev.products.includes(product) ? [] : [product],
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // 유효성 검사
    if (!form.use_purpose.trim()) return alert('사용용도를 입력해주세요.');
    if (form.products.length === 0) return alert('제품을 선택해주세요.');
    if (!form.company_name.trim()) return alert('회사를 입력해주세요.');
    if (!form.author_name.trim()) return alert('성명을 입력해주세요.');
    if (!form.author_phone.trim()) return alert('연락처를 입력해주세요.');

    // 비밀번호 필수 체크 (공개/비공개 선택 상관없이 무조건 체크)
    if (!form.password.trim()) {
      return alert('게시글 비밀번호를 입력해주세요.');
    }

    if (!isQuote && !form.address.trim()) return alert('주소를 입력해주세요.');
    if (isQuote && !form.quantity.trim()) return alert('수량을 입력해주세요.');

    onSubmit(form);
  };

  return (
    <div className="board-write-container request-form-page">
      <div className="request-inner">
        <div className="request-head">
          <span className="request-kicker">{isQuote ? 'QUOTE' : 'SAMPLE'}</span>
          <h2>{pageTitle}</h2>
          <p>{pageDesc}</p>
        </div>

        <form className="request-form-shell" onSubmit={handleSubmit}>
          <div className="request-section">
            {/* 공통 입력 영역 */}
            <div className="input-row full">
              <label>사용용도 *</label>
              <input
                type="text"
                value={form.use_purpose}
                onChange={(e) => handleChange('use_purpose', e.target.value)}
                placeholder="어떤 용도로 사용하실 예정인가요?"
              />
            </div>

            <div className="input-row full">
              <label>{isQuote ? '제품 선택 (중복가능) *' : '샘플요청제품 선택 *'}</label>
              <div className="product-select-box">
                <div className="product-grid">
                  {PRODUCT_LIST.map((product) => (
                    <label
                      key={product}
                      className={`product-option ${form.products.includes(product) ? 'active' : ''}`}
                    >
                      <input
                        type="checkbox"
                        checked={form.products.includes(product)}
                        onChange={() => handleToggleProduct(product)}
                      />
                      <span>{product}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="request-grid two">
              <div className="input-row">
                <label>회사명 *</label>
                <input
                  type="text"
                  value={form.company_name}
                  onChange={(e) => handleChange('company_name', e.target.value)}
                  placeholder="회사명을 입력하세요"
                />
              </div>
              <div className="input-row">
                <label>성명 *</label>
                <input
                  type="text"
                  value={form.author_name}
                  onChange={(e) => handleChange('author_name', e.target.value)}
                  placeholder="담당자 성명"
                />
              </div>
              <div className="input-row">
                <label>연락처 *</label>
                <input
                  type="text"
                  value={form.author_phone}
                  onChange={(e) => handleChange('author_phone', e.target.value)}
                  placeholder="010-0000-0000"
                />
              </div>
              <div className="input-row">
                <label>이메일</label>
                <input
                  type="email"
                  value={form.author_email}
                  onChange={(e) => handleChange('author_email', e.target.value)}
                  placeholder="example@email.com"
                />
              </div>

              {isQuote ? (
                <div className="input-row">
                  <label>희망 수량 *</label>
                  <input
                    type="text"
                    value={form.quantity}
                    onChange={(e) => handleChange('quantity', e.target.value)}
                    placeholder="예: 1,000개"
                  />
                </div>
              ) : (
                <div className="input-row">
                  <label>배송 주소 *</label>
                  <input
                    type="text"
                    value={form.address}
                    onChange={(e) => handleChange('address', e.target.value)}
                    placeholder="샘플을 받으실 상세 주소"
                  />
                </div>
              )}
            </div>

            {/* 비밀번호 입력란 (필수 노출) */}
            <div className="input-row full password-input-area">
              <label>게시글 비밀번호 *</label>
              <input
                type="password"
                value={form.password}
                onChange={(e) => handleChange('password', e.target.value)}
                placeholder="글 조회 및 수정 시 사용할 비밀번호를 입력하세요"
                autoComplete="new-password"
              />
            </div>
          </div>

          <div className="request-actions">
            <button type="button" className="btn-cancel" onClick={onCancel}>
              취소
            </button>
            <button type="submit" className="btn-submit">
              {isQuote ? '견적 문의하기' : '샘플 신청하기'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BoardWrite;
